import { defineComponent as m, openBlock as o, createElementBlock as e, mergeProps as p, unref as n, renderSlot as u, createElementVNode as a, createCommentVNode as V } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, Z = { key: 1 }, f = { key: 2 }, k = { key: 3 }, M = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconExclamationMark"
}, v = /* @__PURE__ */ m({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: l } = A(s);
    return (i, t) => (o(), e("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(d)), [
      u(i.$slots, "default"),
      n(l) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        a("path", { d: "M148,200a20,20,0,1,1-20-20A20,20,0,0,1,148,200Zm-20-40a12,12,0,0,0,12-12V48a12,12,0,0,0-24,0V148A12,12,0,0,0,128,160Z" }, null, -1)
      ]))) : n(l) === "duotone" ? (o(), e("g", Z, t[1] || (t[1] = [
        a("path", {
          d: "M216,40V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V40A16,16,0,0,1,56,24H200A16,16,0,0,1,216,40Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M144,200a16,16,0,1,1-16-16A16,16,0,0,1,144,200Zm-16-40a8,8,0,0,0,8-8V48a8,8,0,0,0-16,0V152A8,8,0,0,0,128,160Z" }, null, -1)
      ]))) : n(l) === "fill" ? (o(), e("g", f, t[2] || (t[2] = [
        a("path", { d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM128,160a12,12,0,1,1-12,12A12,12,0,0,1,128,160Zm-8-24V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Z" }, null, -1)
      ]))) : n(l) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        a("path", { d: "M142,200a14,14,0,1,1-14-14A14,14,0,0,1,142,200Zm-14-42a6,6,0,0,0,6-6V48a6,6,0,0,0-12,0V152A6,6,0,0,0,128,158Z" }, null, -1)
      ]))) : n(l) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        a("path", { d: "M144,200a16,16,0,1,1-16-16A16,16,0,0,1,144,200Zm-16-40a8,8,0,0,0,8-8V48a8,8,0,0,0-16,0V152A8,8,0,0,0,128,160Z" }, null, -1)
      ]))) : n(l) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        a("path", { d: "M140,200a12,12,0,1,1-12-12A12,12,0,0,1,140,200Zm-12-44a4,4,0,0,0,4-4V48a4,4,0,0,0-8,0V152A4,4,0,0,0,128,156Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  v as default
};
